export default "__VITE_ASSET__83Jo50Qn__"